import { EventCountDownTimerUtil } from '../../../shared/utils/event-countdown-timer';
import { Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
	selector: 'app-loan-approval-countdown',
	templateUrl: './loan-approval-countdown.component.html',
	styleUrls: ['./loan-approval-countdown.component.scss']
})
export class LoanApprovalCountdownComponent implements OnInit, OnChanges, OnDestroy {

	@Input() time;
	@Input() showDays;
	@Input() isStaticTime;

	constructor(
		public countDown: EventCountDownTimerUtil
	) { }

	ngOnInit(): void {
		this.countDown.reset();
		clearInterval(this.countDown.timeinterval);
		if (this.isStaticTime) {
			this.setStaticTimeValues();
			return;
		}
		this.countDown.startCountDown(this.time);
	}

	ngOnChanges(changes: SimpleChanges) {
		this.setStaticTimeValues();
	}

	setStaticTimeValues() {
		this.countDown.timer.hours = Math.floor(this.time / 60);
		this.countDown.timer.minutes = Math.floor(this.time % 60);
		this.countDown.timer.seconds = 0;
	}

	ngOnDestroy() {
		this.countDown.reset();
		clearInterval(this.countDown.timeinterval);
	}

}
